/**
 * Created by ALEC on ???
 */



import React from "react";
import { FormattedMessage } from 'react-intl';
import CDNImage from '../media/image.js';
import CDNAudio from '../../classes/audio.js';
import { Table } from 'react-bootstrap';
import { Modal, Collapse, Nav, NavItem, FormControl, Form, FormGroup, ControlLabel, Col, Panel, Row, ButtonGroup, Button } from 'react-bootstrap';
import NoteEdit from '../../components/forms/note-form.js';
import UpdateEdit from '../../components/forms/update-edit.js';


export default class UpdateTable extends React.Component {

    constructor(props) {
        super();
        this.state = {
            changes: props.changes || [],
            edit: props.edit || function () { },
            delete: props.delete || function () { },
            showEdit: false,
            edit: undefined,
            note: undefined
        }

    }

    setData(data) {
        this.setState({ changes: data })
    }


    handleAudioClick(src) {
        (new CDNAudio(src)).play();
    }

    componentWillReceiveProps(props) {
        this.setState({ changes: props.changes || [], edit: props.edit || function () { }, delete: props.delete || function () { } })
    }

    createButton(idx) {
        return <button onClick={function () {
            var change = this.state.changes[idx];
            this.state.delete(change);
        }.bind(this)
        } type="button" className="btn btn-icon command-delete waves-effect waves-circle" data-row-id="10253"><span className="zmdi zmdi-edit"></span></button>
    }

    createButton2(idx, hasNote) {
        var className = "zmdi zmdi-edit";
        if (hasNote){
            className = "zmdi zmdi-flag";
        }
        return <button onClick={function () {
            var change = this.state.changes[idx];
            this.setState({
                showNote: true,
                showEdit: false,
                note: change
            })
        }.bind(this)
        } type="button" className="btn btn-icon command-delete waves-effect waves-circle" data-row-id="10253"><span className={className}></span></button>
    }

    createEditButton(idx) {
        
        return <button onClick={function () {
            var change = this.state.changes[idx];
            this.setState({
                showEdit: true,
                showNote: false,
                edit: change
            })
        }.bind(this)
        } type="button" className="btn btn-icon command-delete waves-effect waves-circle" data-row-id="10253"><span className="zmdi zmdi-edit"></span></button>
    }

    hideNote() {
        this.setState({
            showNote: false,
            note: undefined
        })
    }

    hideEdit() {
        this.setState({
            showEdit: false,
            edit: undefined
        })
    }

    renderRow() {
        var items = [];
        if (this.state.changes == undefined) return <div></div>


        items.push(<tr className={"animate-color p-0"}>

            <td>
                {"Uid"}
            </td>
            <td>
                {"Table"}
            </td>
            <td>
                {"Primary Key"}
            </td>
            <td>
                {"New"}
            </td>
            <td>
                {"Old"}
            </td>
            <td>
                {"Edit Change"}
            </td>
            <td>
                {"Delete Change"}
            </td>
            <td>
                {"Notes"}
            </td>



        </tr>)

        for (var idx = 0; idx < this.state.changes.length; idx++) {
            
            var noteFlag = true;
            if (this.state.changes[idx] != undefined && this.state.changes[idx].note != undefined){
                if (this.state.changes[idx].note[0].note!= "" && 
                    this.state.changes[idx].note[0].note != undefined){
                    noteFlag = false;
                }
            }

            items.push(<tr className={"animate-color p-0"}>
                <td>
                    {this.state.changes[idx].uid}
                </td>
                <td>
                    {this.state.changes[idx].table_ref}
                </td>
                <td>
                    {this.state.changes[idx].prim_key}
                </td>
                <td>
                    {this.state.changes[idx].new_feild}
                </td>
                <td>
                    {this.state.changes[idx].old_feild}
                </td>

                <td width="50" className="text-right">

                    {this.createEditButton(idx)}

                </td>

                <td width="50" className="text-right">

                    {this.createButton(idx)}

                </td>

                <td width="50" className="text-right">
                    {this.createButton2(idx, noteFlag)}

                </td>
                    

            </tr>)
        }

        return items;
    }
    render() {
        return (
            <div>
                <Modal show={this.state.showNote} onHide={this.hideNote.bind(this)} bsSize="large" aria-labelledby="contained-modal-title-lg">
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="p-10">
                            <NoteEdit note={this.state.note} submit={this.hideNote.bind(this)} ></NoteEdit>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={this.state.showEdit} onHide={this.hideEdit.bind(this)} bsSize="large" aria-labelledby="contained-modal-title-lg">
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="p-10">
                            <UpdateEdit update={this.state.edit}  submit={this.hideEdit.bind(this)} ></UpdateEdit>
                        </div>
                    </Modal.Body>
                </Modal>

                <Table condensed striped responsive bordered>
                    <tbody>
                        {this.renderRow()}
                    </tbody>
                </Table>



            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/tables/update-table.js